// store/modules/rentalPeriods.js
import axios from 'axios'
import store from "@/store"

const state = {
  periodList: [],
}

const mutations = {
  SET_PERIOD_LIST(state, periodList) {
    state.periodList = periodList
  },
}

const actions = {
  async fetchRentalPeriods({ commit }) {
    try {
      const response = await store.dispatch('api/fetchRentalPeriodsListFull')
      const periods = response.data.map(period => ({
        label: period.name,
        value: period.id,
      }))

      commit('SET_PERIOD_LIST', periods)
    } catch (error) {
      console.error('Failed to fetch rental periods:', error)
    }
  },
}

const getters = {
  getPeriodList: (state) => state.periodList,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
